import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import { dateTime, pageNumbers, POSTS_PER_PAGE, userLink } from '../utils';

/**
 * Riga della lista topic phpBB: icona di stato, titolo con mini paginazione, autore e data; risposte, visite,
 * ultimo messaggio. Va al posto del contenuto di DiscussionListItem (i controlli restano).
 */
export default function topicRow(discussion) {
  const posts = (discussion.replyCount() ?? 0) + 1;
  const pages = Math.ceil(posts / POSTS_PER_PAGE);
  const views = discussion.attribute('phpbbViews');
  const icon = [discussion.isSticky?.() ? 'sticky' : 'topic', discussion.isUnread() ? 'unread' : 'read', discussion.isLocked?.() ? 'locked' : null].filter(Boolean).join('_');
  return m("dl", {
    className: `TopicRow ForumTable-icon ForumTable-icon--${icon}`
  }, m("dt", null, m("div", {
    className: "TopicRow-title"
  }, m(Link, {
    className: "TopicRow-name",
    href: app.route.discussion(discussion)
  }, discussion.title()), m("div", {
    className: "TopicRow-author"
  }, pages > 1 && m("span", {
    className: "TopicRow-pages"
  }, pageNumbers(pages).map(page => page === null ? m("span", {
    className: "TopicRow-ellipsis"
  }, "...") : m(Link, {
    href: app.route.discussion(discussion, (page - 1) * POSTS_PER_PAGE + 1)
  }, page))), "by ", userLink(discussion.user()), " \xBB ", dateTime(discussion.createdAt())))), m("dd", {
    className: "ForumTable-count"
  }, discussion.replyCount(), " ", m("dfn", null, "Replies")), m("dd", {
    className: "ForumTable-count"
  }, views ?? 0, " ", m("dfn", null, "Views")), m("dd", {
    className: "ForumTable-last"
  }, m("span", null, m("dfn", null, "Last post "), "by ", userLink(discussion.lastPostedUser()), ' ', m(Link, {
    className: "ForumTable-latest",
    href: app.route.discussion(discussion, discussion.lastPostNumber()),
    title: "View the latest post"
  }, m("span", {
    className: "sr-only"
  }, "View the latest post")), m("br", null), dateTime(discussion.lastPostedAt()))));
}
flarum.reg.add('runeaudio-theme', 'forum/components/TopicRow', topicRow);